import { buildUrl } from '../../../utils/api';

export const fetchSiteActionsURL = (id: string) =>
  buildUrl(`/api/v3/adm/site/${id}/actions`);
